export class HistorysService {
  constructor (api) {
    this.api = api
  }

  getHistorys = () => this.api.get('/schedules?assetType=DEVCONFIG-text/xml-hon-license-config')
}
